import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {SelectFilterElement} from '../../../../../../components/common/select-filter/select-filter.model';
import {DocumentSummaryModel} from '../../model/documentSummary.model';
import {UntypedFormGroup} from '@angular/forms';

@Component({
  selector: 'app-document-multiple-select-filter',
  templateUrl: './document-multiple-select-filter.component.html'
})
export class DocumentMultipleSelectFilterComponent implements OnInit, OnChanges {

  @Input() parentFormGroup: UntypedFormGroup;
  @Input() parentFormControlName: string;
  @Input() documents: DocumentSummaryModel[] = [];

  elements: BehaviorSubject<SelectFilterElement<number, DocumentSummaryModel>[]> =
      new BehaviorSubject<SelectFilterElement<number, DocumentSummaryModel>[]>([]);

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['documents']) {
      this.elements.next(this.documents.map(value =>
          new SelectFilterElement<number, DocumentSummaryModel>(value.id, value.id, value)));
    }
  }

  filter = (criteria: string, document: DocumentSummaryModel) => {
    return (document.label).toUpperCase().indexOf(criteria.toUpperCase()) > -1;
  }

  ngOnInit() {}

}
